import { Button, Icon } from '@orionprotocol/ui';
import { formatTickerOrAddress } from '@orionprotocol/utils';

import { useWalletAddress, useWalletType } from '../../../shared/api';
import { HeaderDropdown } from '../../../entities/wallets';

import styles from './HeaderWallet.module.scss';

export function HeaderWallet(): JSX.Element {
  const walletType = useWalletType();
  const walletAddress = useWalletAddress();
  const walletAddressCropped = formatTickerOrAddress(walletAddress, 7, 6);

  return (
    /* TODO: change to Dropdown */
    <HeaderDropdown className={styles.root}>
      <Button type="outlined" size="m" className={styles.button}>
        <Icon
          collection="wallet"
          icon={walletType?.toLowerCase() ?? 'close'}
          type="color"
        />
        <span>{walletAddressCropped}</span>
      </Button>
    </HeaderDropdown>
  );
}
